/**
 * Opens the native date picker when the user clicks anywhere on a date field (not only the calendar icon).
 */
(function () {
  function bindDateInputs(form) {
    if (!form) return;

    form.querySelectorAll('input[type="date"]').forEach(function (input) {
      if (input.dataset.cfDateClickBound === '1') return;
      input.dataset.cfDateClickBound = '1';

      input.addEventListener('click', function () {
        if (typeof input.showPicker !== 'function') return;
        try {
          input.showPicker();
        } catch (e) {
          /* Some browsers throw if not allowed or already open */
        }
      });
    });
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.contact-form__form').forEach(bindDateInputs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) init(ev.target);
  });
})();
